export { ImageOcclusionBox, ImageOcclusionBoxProps } from './ImageOcclusionBox';
